import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RhEvent } from '../api/models/RhEvent';

type State = {
  list: RhEvent[];
};

export const eventSlice = createSlice({
  name: 'event',
  initialState: {
    list: [],
  } as State,
  reducers: {
    receivedList: (state, action: PayloadAction<{ events: RhEvent[] }>) => {
      state.list = action.payload.events;
    },
  },
});
